<!--
  @Description 奖惩设置
  @Date 2021-12-23
  @Author liushuo
-->
<template>
  <div>
    <vxe-grid
      ref="xTable"
      resizable
      :column-config="{ minWidth: '80px' }"
      :data="tableData"
      :toolbar-config="tableToolbar"
      @toolbar-button-click="toolbarButtonClickEvent"
      size="mini"
      :mouse-config="{ area: true, extension: true }"
      highlight-hover-row
      highlight-current-row
      :height="tableHeight"
      :columns="gridColumns"
      :menu-config="{
        body: { options: bodyMenus },
        visibleMethod: visibleMethod,
      }"
      :edit-rules="validRules"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod,
      }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        enterToTab: true,
        isClip: true,
        isEdit: true,
        editMethod: editMethod,
      }"
      @menu-click="contextMenuClickEvent"
      @cell-menu="cellContextMenuEvent"
    >
    </vxe-grid>
    <PickPosition
      ref="PickPosition"
      :positionOptions="positionOptions"
      :visiblePosition="selectVisiblePositionArr"
      @sureBackPosition="sureBackPosition"
      :isMultiple="false"
    />
  </div>
</template>

<script>
export default {
  name: 'jiangcheng',
  props: {
    searchFormVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [
      ],
      gridColumns: [
        { type: 'seq', width: 40 },
        { title: '类型', field: 'todo1', editRender: { name: 'input', attrs: { disabled: true } } },
        { title: '岗位', field: 'todo2', editRender: { name: 'input', attrs: { disabled: true } } },
        { title: '超期次数', field: 'todo3', editRender: { name: 'input' } },
        { title: '奖惩', field: 'todo4', editRender: { name: 'input', attrs: { disabled: true } } },
        { title: '金额(元)', field: 'todo5', editRender: { name: 'input' } }
      ],
      // 右键菜单
      bodyMenus: [[
        {
          code: 'todo1',
          name: '错误'
        },
        {
          code: 'todo1',
          name: '超期'
        },
        {
          code: 'todo1',
          name: '延期超期'
        },
        {
          code: 'todo1',
          name: '下发'
        },
        {
          code: 'todo2',
          name: '选择岗位'
        },
        {
          code: 'todo2',
          name: '清空'
        },
        {
          code: 'todo4',
          name: '奖励'
        },
        {
          code: 'todo4',
          name: '罚款'
        },
      ]],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // tabel工具栏
      tableToolbar: {
        buttons: [
          { code: 'insertOne', name: '新增1行' },
          { code: 'insertTen', name: '新增10行' },
        ],
      },
      // 下拉框
      positionOptions: [],
      selectVisiblePositionArr: [],
      //右键缓存
      areas: {},
      colProperty: '',
      // todo 明细验证规则
      validRules: {
        todo1: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        todo4: [
          { required: true, message: '请选择奖惩类型', trigger: 'change' }
        ]
      },
    }
  },
  created () {
    this.BindComBox()
  },
  methods: {
    // 获取下拉框数据
    async BindComBox () {
      this.positionOptions = []
      const { data: selectRes } = await this.$http.get('/Common/YKUser/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'UserPost':
              this.positionOptions.push(item)
              break
          }
        }
      }
    },
    cellContextMenuEvent ({ column }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
    },
    // 右键控制菜单方法
    visibleMethod ({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = !this.$parent.Authority.edit
          if (item.code === column.property) {
            item.visible = true
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent ({ menu, row }) {
      switch (menu.code) {
        case 'todo1':
        case 'todo4':
          this.areas.forEach(area => {
            for (let row of area.rows) {
              for (let col of area.cols) {
                if (col.property === this.colProperty) {
                  row[col.property] = menu.name
                }
              }
            }
          })
          break
        case 'todo2':
          switch (menu.name) {
            case '选择岗位':
              this.selectVisiblePositionArr = []
              if (!row['post'] || row['post'] === '') {
                this.selectVisiblePositionArr = []
              } else if (row['post'] !== '' && String(row['post']).indexOf(',') === -1) {
                this.selectVisiblePositionArr = [row['post']]
              } else {
                this.selectVisiblePositionArr = String(row['post']).split(',')
              }
              this.$refs.PickPosition.formVisible = true
              break
            case '清空':
              this.areas.forEach(area => {
                for (let row of area.rows) {
                  for (let col of area.cols) {
                    if (col.property === this.colProperty) {
                      row[col.property] = ''
                    }
                  }
                }
              })
              break
          }
          break
      }
    },
    // 返回职位
    sureBackPosition (post) {
      this.areas.forEach((area) => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            switch (col.property) {
              case 'todo2':
                row[col.property] = post
                break
            }
          }
        }
      })
    },
    // table工具栏方法
    toolbarButtonClickEvent ({ code }) {
      switch (code) {
        case 'insertOne':
          this.insertEvent()
          break
        case 'insertTen':
          this.insertTenEvent()
          break
      }
    },
    // 新增一行
    insertEvent () {
      let record = {}
      this.$refs.xTable.insertAt(record, -1)
      // this.IfExistModify = true
    },
    // 新增10行
    insertTenEvent () {
      let record = {}
      for (var i = 0; i < 10; i++) {
        this.$refs.xTable.insertAt(record, -1)
      }
      // this.IfExistModify = true
    },
    // cell激活控制
    activeMethod ({ column }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.$parent.Authority.edit) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod ({ row, column, $table }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.$parent.Authority.edit) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
  },
  computed: {
    tableHeight () {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
  }
}
</script>

<style lang="less" scoped>
</style>
